export default "__VITE_ASSET__15e41f70__"